import "./App.css";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.js";
import {createTheme, ThemeProvider} from "@mui/material/styles";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import {useEffect, useState} from "react";

import {NotificationContainer} from "react-notifications";
import "react-notifications/lib/notifications.css";
import "./common/notifications/notification.css";
import AppInner from "./AppInner";
import {axiosConfig} from "./axios";
import {GlobalProvider} from "./GlobalContext";

const theme = createTheme({
    palette: {
        primary: {
          main: '#005A8C'
        },
        text: {
            primary: '#005A8C', // rgb(0, 90, 140)
        },
    },
    typography: {
        fontFamily: "Gilroy-Regular, sans-serif",
        body1: {
            fontFamily: "Gilroy-Regular, sans-serif",
            fontSize: '16px',
        },
        body2: {
            fontFamily: "Gilroy-Regular, sans-serif",
        },
    },
    components: {
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    fontFamily: "Gilroy-Medium, sans-serif",
                    fontSize: '16px',
                    color: '#444444',
                },
            },
        },

        MuiCard: {
            styleOverrides: {
                root: {
                    // Tremor-style borders and shadows
                    borderRadius: '8px', // rounded-lg equivalent
                    border: '1px solid #e5e7eb', // border-gray-200
                    boxShadow: '0 1px 2px 0 rgb(0 0 0 / 0.05)', // shadow-sm equivalent
                    backgroundColor: '#ffffff', // bg-white

                    // Remove MUI's default elevation shadow
                    '&.MuiPaper-elevation1': {
                        boxShadow: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
                    },
                },
            },
        },
        MuiCardContent: {
            styleOverrides: {
                root: {
                    padding: '24px', // p-6 equivalent (24px)
                    '&:last-child': {
                        paddingBottom: '24px', // Override MUI's default last-child padding
                    },
                },
            },
        },
    }
});


function App() {
    useEffect(() => {
        axiosConfig();
    },[]);

    const [queryClient] = useState(() => new QueryClient());

    return (
        <GlobalProvider>
            <NotificationContainer/>
            <ThemeProvider theme={theme}>
                <QueryClientProvider client={queryClient}>
                    <AppInner/>
                </QueryClientProvider>
            </ThemeProvider>
        </GlobalProvider>
    );
}

export default App;
